import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useAriaOptionsFunction(): (count: number) => string {
  const { t } = useTranslation()
  return useMemo(() => {
    return (count: number): string =>
      t('orderWizardSingleSelectFilteredResultsAvailable', {
        count,
      })
  }, [t])
}
